import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=1f08a63e&scoped=true&"
import script from "./NavBarItem.vue?vue&type=script&lang=js&"
export * from "./NavBarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&id=1f08a63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f08a63e",
  null
  
)

export default component.exports